import { createFileRoute } from "@tanstack/react-router";
import { zodValidator, fallback } from "@tanstack/zod-adapter";
import { z } from "zod";
import { AgenciasPanel } from "@/components/admin/AgenciasPanel";
import { ORDENES_AGENCIAS, ORDEN_AGENCIAS_DEFECTO } from "@/lib/agencias-orden";

const searchSchema = z.object({
  open: z.string().uuid().optional(),
  page: fallback(z.number().int().min(1), 1).default(1),
  pageSize: fallback(z.union([z.literal(50), z.literal(100), z.literal(200)]), 50).default(50),
  orden: fallback(z.enum(ORDENES_AGENCIAS), ORDEN_AGENCIAS_DEFECTO).default(ORDEN_AGENCIAS_DEFECTO),
});

export const Route = createFileRoute("/admin/agencias")({
  validateSearch: zodValidator(searchSchema),
  component: AgenciasPanel,
});
